import firebase from 'firebase/app';

const storage = firebase.storage();

if (process.env.REACT_APP_ENVIRONMENT_NAME === 'EMULATOR') {
  storage.useEmulator('localhost', 9199);
}

export default storage;
